<template>
  <TourClassicNavigation />

  <div class="w-full max-w-4xl mx-auto flex flex-col gap-2 px-2 mt-2">
    <slot />
  </div>

  <Footer />
</template>
